// extracted by mini-css-extract-plugin
export default {"imageWrapper":"XN-z","twoColumnImage":"YN-z"};